<nav>
  <ul>
    @for(category of categories; track category){
      <li>
        <a href="javascript:void(0)" [routerLink]="['/category', category.slug]">
          {{ category.name }}
        </a>
      </li>
    }
  </ul>
</nav>
